import React from 'react';
import '../css/Menu.css'

const Menu = () => {

  return(
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					<div className="page_title text-center mb-4">
						<h1>our menu</h1>
						<div className="single_line"></div>
					</div>
				</div>
			</div>
			{/* <div className="row">
				<ul className="nav nav-tabs nav-justified menu_tab" id="myTab" role="tablist">
					<li className="nav-item">
						<a className="nav-link active" id="vegetables-tab" data-toggle="tab" href="#vegetables" role="tab">Vegetables</a>
					</li>
					<li className="nav-item">
						<a className="nav-link" id="fruits-tab" data-toggle="tab" href="#fruits" role="tab">Fruits</a>
					</li>
				</ul>
        	</div> */}
	</div>
    )
}

export default Menu;